// Client-side "seen onboarding" flag. Deliberately not persisted server-side:
// completing a player profile is a player concern, not an obligation on league
// admins / managers, so there's no per-account "profile completed" state.
const dismissalKey = (userPk) => `ls-onboarding-dismissed-${userPk}`;
export const isOnboardingDismissed = (userPk) => localStorage.getItem(dismissalKey(userPk)) === "1";
export const dismissOnboarding = (userPk) => localStorage.setItem(dismissalKey(userPk), "1");
